<template>
  <div class="snippet snippet_full" :class="{ _selected: selected }">
    <header class="snippet__header">
      <div
        class="snippet__base-icon"
        :style="dbIconStyle"
        :title="dbName"
      ></div>

      <router-link
        v-if="designation"
        class="snippet__designation"
        :to="documentRoute"
        :target="openInNewWindow ? '_blank' : ''"
      >
        {{ designation }}
      </router-link>

      <div class="snippet__status">
        <svg class="icon-status snippet__icon-status" width="22" height="22">
          <use :xlink:href="statusIcon" />
        </svg>

        <div class="snippet__status-hint">
          {{ item.statusHint }}
        </div>
      </div>

      <time class="snippet__date">
        {{ item.approvalDate | formatDate }}
      </time>

      <div class="snippet__doc-types">
        <router-link
          v-if="isCollection"
          :to="documentRoute"
          class="snippet__doc-type snippet__package"
        >
          <svg width="22" height="22">
            <use xlink:href="#document--package" />
          </svg>
          <span>сборник</span>
        </router-link>

        <template v-else-if="isAccessFull(item.accessLevel)">
          <router-link
            v-if="documentHtmlRoute"
            :to="documentHtmlRoute"
            class="snippet__doc-type"
            :target="openInNewWindow ? '_blank' : ''"
          >
            <svg width="52" height="26">
              <use xlink:href="#document--text" />
            </svg>
          </router-link>

          <router-link
            v-if="documentScanRoute"
            :to="documentScanRoute"
            class="snippet__doc-type"
            :target="openInNewWindow ? '_blank' : ''"
          >
            <svg width="52" height="26">
              <use xlink:href="#document--scan" />
            </svg>
          </router-link>
        </template>
      </div>
    </header>

    <div class="snippet__title">
      <router-link
        :to="documentRoute"
        class="snippet__link"
        :target="openInNewWindow ? '_blank' : ''"
      >
        {{ item.title }}
      </router-link>
    </div>

    <div v-if="item.area" class="snippet__area">
      {{ item.area | sanitizeText | truncateText(140) }}
    </div>

    <div class="snippet__footer">
      <div v-if="amendment" class="snippet__amendment">
        {{ amendment }}
      </div>

      <div class="snippet__footer-options">
        <button-watch :active="item.isWatched" @click="onButtonWatchedClick" />

        <button-favorite
          :active="item.isFavorite"
          @click="onButtonFavoriteClick"
        />

        <span
          class="snippet__card"
          :class="{ _active: selected && cardOpened }"
          title="Карточка документа"
          @click="onCardClick"
        >
          <svg width="22" height="22">
            <use xlink:href="#document--card" />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { DOCUMENT_KIND_COLLECTION } from '@src/api/documents';
import { DOCUMENT_ACCESS_LEVEL_FULL } from '@src/api/entities/ApiDocumentSearchCard';

import ButtonFavorite from '@@/document/DocumentToolbar/ButtonFavorite';
import ButtonWatch from '@@/document/DocumentToolbar/ButtonWatch';

import SearchResultItem from '@@/search/mixins/SearchResultItem';

export default {
  components: {
    ButtonFavorite,
    ButtonWatch
  },

  mixins: [SearchResultItem],

  props: {
    selected: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(['sidebarStatus']),
    openInNewWindow() {
      return this.$store.getters.getOpenInWindow;
    },
    designation() {
      if (this.item.designation) return this.item.designation;
        
      let type = this.item.type;
      let number = this.item.number;

      return type + (type && number ? ' ' : '') + number;
    },
    isCollection() {
      return this.item.kind.includes(DOCUMENT_KIND_COLLECTION);
    },
    cardOpened() {
      return this.sidebarStatus === 'card';
    }
  },

  methods: {
    isAccessFull(accessLevel) {
      return accessLevel === DOCUMENT_ACCESS_LEVEL_FULL;
    },
    async onCardClick() {
      await this.$store.dispatch('setCurrentDocumentId', this.item.id);
      this.$emit('card-click', this.item.id);
    }
  }
};
</script>
